/**
 * @generated SignedSource<<e9b239acda86d651841ef80e09b7a650>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrgWorkspaceCreateMutation$variables = {
  name: string;
  timezone: string;
  workspaceId: string;
};
export type OrgWorkspaceCreateMutation$data = {
  readonly workspace: {
    readonly createSubWorkspace: {
      readonly id: string;
      readonly org: {
        readonly workspaces: ReadonlyArray<{
          readonly " $fragmentSpreads": FragmentRefs<"WorkspaceSelector_workspaces">;
        }>;
      } | null;
    } | null;
  };
};
export type OrgWorkspaceCreateMutation = {
  response: OrgWorkspaceCreateMutation$data;
  variables: OrgWorkspaceCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "timezone"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "workspaceId"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "name",
    "variableName": "name"
  },
  {
    "kind": "Variable",
    "name": "timezone",
    "variableName": "timezone"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "OrgWorkspaceCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "WorkspaceMutation",
        "kind": "LinkedField",
        "name": "workspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "Workspace",
            "kind": "LinkedField",
            "name": "createSubWorkspace",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Organisation",
                "kind": "LinkedField",
                "name": "org",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Workspace",
                    "kind": "LinkedField",
                    "name": "workspaces",
                    "plural": true,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "WorkspaceSelector_workspaces"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "OrgWorkspaceCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "WorkspaceMutation",
        "kind": "LinkedField",
        "name": "workspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "Workspace",
            "kind": "LinkedField",
            "name": "createSubWorkspace",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Organisation",
                "kind": "LinkedField",
                "name": "org",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Workspace",
                    "kind": "LinkedField",
                    "name": "workspaces",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "parentId",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ec59b33e89fee2a1685d5b5620765586",
    "id": null,
    "metadata": {},
    "name": "OrgWorkspaceCreateMutation",
    "operationKind": "mutation",
    "text": "mutation OrgWorkspaceCreateMutation(\n  $name: String!\n  $workspaceId: ID!\n  $timezone: String!\n) {\n  workspace(id: $workspaceId) {\n    createSubWorkspace(name: $name, timezone: $timezone) {\n      id\n      org {\n        workspaces {\n          ...WorkspaceSelector_workspaces\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment WorkspaceSelectorContent_workspaces on Workspace {\n  id\n  name\n  parentId\n}\n\nfragment WorkspaceSelector_workspaces on Workspace {\n  id\n  name\n  parentId\n  ...WorkspaceSelectorContent_workspaces\n}\n"
  }
};
})();

(node as any).hash = "224f76543c7117c557c3c6b2f4aeed24";

export default node;
